/**
 * IGT / RXConnect DimPatron_* pipe extract — ~30 columns, no header.
 * Column layout: docs/data/DimPatron-overview.md (gender = 0-based col 22).
 */

export const IGT_PATRON_PIPE_SOURCE_LABELS = {
  0: 'player_id',
  1: 'membership_number',
  2: 'expiry_date',
  3: 'membership_status',
  4: 'membership_tier',
  5: 'site_name',
  6: 'card_number',
  7: 'full_name',
  8: 'dob',
  9: 'birth_month',
  10: 'join_date',
  11: 'test_flag',
  12: 'record_status',
  13: 'country',
  14: 'state',
  15: 'postcode',
  16: 'suburb',
  17: 'address1',
  18: 'address2',
  19: 'email',
  20: 'phone',
  21: 'points_balance',
  22: 'gender',
  23: 'site_name_2',
  24: 'site_code',
  25: 'site_numeric',
  26: 'hierarchy_level',
  27: 'group_type',
  28: 'site_name_3',
  29: 'site_name_4',
}

export const IGT_PATRON_PIPE_MAPPINGS = {
  PatronID: 'player_id',
  MembershipNumber: 'membership_number',
  FullName: 'full_name',
  DateOfBirth: 'dob',
  JoinDate: 'join_date',
  ExpiryDate: 'expiry_date',
  MembershipStatus: 'membership_status',
  MembershipTier: 'membership_tier',
  CardNumber: 'card_number',
  Email: 'email',
  Phone: 'phone',
  Gender: 'gender',
  Country: 'country',
  State: 'state',
  Postcode: 'postcode',
  Suburb: 'suburb',
  Address1: 'address1',
  Address2: 'address2',
  PointsBalance: 'points_balance',
  VenueCode: 'site_code',
  TestFlag: 'test_flag',
  RecordStatus: 'record_status',
}

export const PATRON_FIELD_HINTS = {
  PatronID: 'Col 0 — IGT player id (gaming sessions)',
  MembershipNumber: 'Col 1 — club membership number (staff / PiG)',
  FullName: 'Col 7',
  DateOfBirth: 'Col 8',
  Gender: 'Col 22 — M / F (not site name at col 23)',
  VenueCode: 'Col 24 — site code (e.g. WT)',
  MembershipStatus: 'Col 3 — Financial, Archived, …',
  MembershipTier: 'Col 4 — ORDINARY, PENSIONER, …',
}

export function referenceIgtPatronTemplateContent() {
  return {
    sourceFormat: 'pipe-delimited',
    hasHeader: false,
    venueCode: 'WT',
    sourceLabels: { ...IGT_PATRON_PIPE_SOURCE_LABELS },
    mappings: { ...IGT_PATRON_PIPE_MAPPINGS },
  }
}

/** Resolve mapping source (label or numeric index) to 0-based column index. */
export function resolveSourceLabelToColumn(source, sourceLabels = {}) {
  if (source == null || String(source).trim() === '') return null
  const s = String(source).trim()
  const n = parseInt(s, 10)
  if (!Number.isNaN(n) && String(n) === s) return n
  for (const [idx, label] of Object.entries(sourceLabels)) {
    if (label === s) return parseInt(idx, 10)
  }
  return null
}
